<template lang="pug">
.navigation-wrapper
  .left
    .logo(@click="$router.push('/')")
      .image
        img(src="@/assets/logo.svg" alt="fewo manager logo")
    .items
      .item(:class="{active: $route.name === 'Dashboard'}" @click="$router.push('/')")
        svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
          path(d='M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z')
          polyline(points='9 22 9 12 15 12 15 22')
        |Dashboard
      .item(:class="{active: $route.name === 'BookingCalendar'}" @click="$router.push('/bookingcalendar')")
        svg(viewbox='0 0 24 24' width='24' height='24' stroke='currentColor' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round')
          rect(x='3' y='4' width='18' height='18' rx='2' ry='2')
          line(x1='16' y1='2' x2='16' y2='6')
          line(x1='8' y1='2' x2='8' y2='6')
          line(x1='3' y1='10' x2='21' y2='10')
        |Buchungskalender
      .item(:class="{active: $route.name === 'ListsOverview'}" @click="$router.push('/lists')")
        svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
          path(d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2')
          rect(x='8' y='2' width='8' height='4' rx='1' ry='1')
        |Listen
      .item(:class="{active: $route.name === 'StatisticsOverview'}" @click="$router.push('/statistics')")
        svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
          path(d='M21.21 15.89A10 10 0 1 1 8 2.83')
          path(d='M22 12A10 10 0 0 0 12 2v10z')
        |Statistiken
    //-   .item(:class="{active: $route.name === 'FinancesOverview'}" @click="$router.push('/finances')")
    //-     svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
    //-       line(x1='12' y1='1' x2='12' y2='23')
    //-       path(d='M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6')
    //-     |Finanzen
  .right
    .items
      .nav-icon(v-tooltip.top-center="'Website verwalten'" :class="{active: $route.name === 'CMSOverview'}" @click="$router.push('/cms')")
        svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
          rect(x='3' y='3' width='18' height='18' rx='2' ry='2')
          line(x1='3' y1='9' x2='21' y2='9')
          line(x1='9' y1='21' x2='9' y2='9')
      .nav-icon(v-tooltip.top-center="'Stammdaten'" :class="{active: $route.name === 'DataOverview'}" @click="$router.push('/data')")
        svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
          ellipse(cx='12' cy='5' rx='9' ry='3')
          path(d='M21 12c0 1.66-4 3-9 3s-9-1.34-9-3')
          path(d='M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5')
      .nav-icon(v-tooltip.top-center="'Einstellungen'" :class="{active: $route.name === 'Settings'}" @click="$router.push('/settings')")
        svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
          circle(cx='12' cy='12' r='3')
          path(d='M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z')
      ProfileIcon
</template>

<script>
import ProfileIcon from "@/components/atoms/ProfileIcon.vue";
export default {
  components: {
    ProfileIcon
  },
  async beforeMount() {
    // When logged in we try to get the user information
    await this.$store.dispatch("me/getMe");
  }
};
</script>

<style lang="scss" scoped>
.navigation-wrapper {
  background-color: white;
  position: relative;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  border-right: solid 1px darken($light, 4%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);

  .left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .right {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .items {
      margin-right: $sm-space;
    }
  }

  .logo {
    position: relative;
    padding: $lg-space;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .items {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .item {
      position: relative;
      cursor: pointer;
      svg {
        margin-right: $xs-space;
      }
      font-size: 13px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-radius: 3px;
      // margin: $md-space 0;
      padding: 12px $sm-space;
      &:hover {
        background-color: $light;
        // color: white;
      }
      &.active {
        color: $primary;
      }
      .badge {
        position: absolute;
        top: 6px;
        right: -8px;
        font-size: 10px;
        border-radius: 99px;
        background-color: lightcyan;
        padding: 1px 4px;
        color: $primary;
      }
    }
    .nav-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 $sm-space;
      &:hover {
        cursor: pointer;
        color: $primary;
      }
      &.active {
        color: $primary;
      }
    }
  }
  .version {
    position: absolute;
    bottom: $sm-space;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    background-color: white;
    border-radius: 4px;
    padding: 0px 6px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
  }
}
</style>
